import React , {useState , useEffect} from 'react'
import {Grid , Box , InputLabel ,  TextField , Menu , MenuItem  , Typography, FormHelperText, TextareaAutosize} from "@mui/material"

import MultipleSelect from '../../shared/multipleSelect'
import CustomRadiobtn from '../../shared/CustomRadioBtns'
import { useDispatch , useSelector } from 'react-redux'

import MoreHorizIcon from "@mui/icons-material/MoreHoriz"
import CustomButton from '../../shared/CustomButton'
import FormikAutocomplete from '../../shared/AutoCompelete'
import EditInline from '../../shared/EditInline'
import {getField} from '../state/alertActions'
import { direction , operatorOptionsText } from '../../../utils/constantDropdowns'
const AlertOnText = ({
  messageTypes,
  Templates,
  current,
  touched,
  setTouched,
  formik,
  menu,
  handleClick,
  handleClose,
  anchorEl
}) => {
 
      const [alertTypeValue,setAlertTypeValue]=useState('')
   
      const [selectedReceivers, setSelectedReceivers] = useState([]);
  const [selectedccReceivers, setSelectedccReceivers] = useState([]);
      const [finalMenu,setFinalMenu]=useState(menu)
const dispatch = useDispatch()
const {messageFields} = useSelector((state) => state.internalAlertRules)


const styleAuto = {
  width: "360px",
  resize: "none",
  padding:"7px 5px",
  borderRadius: "4px",
  border: "1px solid #DBDEE6",
  fontFamily: "Roboto",
fontSize:"14px",
lineHeight:"1.5"
}


  /*     useEffect(() => {
     
        if (!formik.values.templateId) {
         let Template = Templates?.Text.filter((temp) => temp.isDefault)[0]
   
         formik.setFieldValue("templateId", Template);
       }
     }, [Templates.Text,formik]) */


useEffect(() => {
   
  if(current.messageType === "")
  {
    formik.setFieldValue("messageField",'')
    dispatch({type:"RESET_FIELDS"})
  }
  else {
    dispatch(getField(current.messageType))
  }
},[dispatch,current.messageType])

      useEffect(() => {
        if (formik.values.receivers?.length > 0) {
          setSelectedReceivers(formik.values.receivers);
        }else 
        {
          setSelectedReceivers([]);

        }
      },[formik.values.receivers]);
    
      useEffect(() => {
        if (formik.values.ccReceivers?.length > 0) {
          
          setSelectedccReceivers(formik.values.ccReceivers);
        }
        else {
          setSelectedccReceivers([]);

        }
      },[formik.values.ccReceivers]);
      useEffect(() => {
    
        if (formik.values.notificationType) {
          setAlertTypeValue(formik.values.notificationType);
        }else {
          setAlertTypeValue(formik.values.notificationType);
        }
      }, [formik.values.notificationType]);
      
      const handleChange = (e) => {
        console.log(e.target.value);
        if (!touched) setTouched(true);
        formik.handleChange(e);
      };

      const handleChangeEmail = (newValue) => {
        if (!touched) setTouched(true);
        formik.setFieldValue("receivers", newValue);
      };
    
      const handleChangeccEmail = (newValue) => {
        if (!touched) setTouched(true);
        formik.setFieldValue("ccReceivers", newValue);
      };
    
      const HandleChangeChannel = (newvalue) => {
        if (!touched) setTouched(true);
        formik.setFieldValue("notificationType", newvalue);
        if(formik.values.id === -1 )
        {
          formik.setFieldValue("receivers", '');
        }
      };
     
    
    
  return (
    <>
  
    <Grid
    container
    alignItems="center"
    justifyContent="space-between"
    sx={{ width: "100%" }}
  >
      <Grid flex={0.5} sx={{ marginBottom: "7px"}}>
          <Typography sx={{}}>
          <EditInline
            formik={formik}
            handleChange={handleChange}
            name="name"
            placeholder={"Enter Criteria Name"}    
            />
            </Typography>
        </Grid>
 {formik.values.id !== -1 && 
    <Grid sx={{
        display:"flex",
        gap: "20px",             
        alignItems:"center",
        backgroundColor: "#E7E9EF",
        borderRadius:"2px",
        p:0.1



}}>
   
    <MoreHorizIcon 
    sx={{ color: "#50566E" }}
    aria-controls="accordian-menu"
    aria-haspopup="true"
    onClick={finalMenu?.length ? handleClick : null}
    />
    <Menu
            id="accordian-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            {finalMenu && React.Children.toArray(finalMenu?.map((el) => {
              return (
                <div style={{ width: "200px" }}>
                  <MenuItem
                    onClick={(e) => {
                      
                      e.stopPropagation();
                      el.handler(formik.values);
                      handleClose();
                    }}
                  >
                    {el.action}
                  </MenuItem>
                </div>
              );
            }))}
          </Menu>
    </Grid>
}
</Grid>    
<>

  
<Grid item xs={12} mb={3}>
<Box
display={"flex"}
gap={"10px"}
>
<Box>
<InputLabel
              
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: "bold",
                letterSpacing: "-0.5px",
                lineHeight: "16px",
                marginBottom: "5px",
                pb: 1,
                pt: 1,
              }}
            >
              Message Type
    </InputLabel>

    <FormikAutocomplete 
 options={messageTypes}
 getOptionLabel={(option) => (option.name ? option.name : '')}
 width={200}
 value={formik.values.messageType}
 name="messageType"
 formik={formik}
 label="select messageType"
 height={"36px"}
 setTouched={setTouched}
 touched={touched}
 setChangeEvent={(e) => {
  formik.setFieldValue('messageField','')
  dispatch(getField(e))
  
  
}} 
/>
{formik.touched.messageType && Boolean(formik.errors.messageType) && (
   <FormHelperText sx={{ color: "#d32f2f" }}>
             {formik.errors.messageType}
       </FormHelperText>
          )}
</Box>

<Box>
<InputLabel
              htmlFor="bankName"
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: "bold",
                letterSpacing: "-0.5px",
                lineHeight: "16px",
                marginBottom: "5px",
                pb: 1,
                pt: 1,
              }}
            >
               Way
    </InputLabel>

    <FormikAutocomplete 
 options={direction}
 width={200}
 isOptionEqualToValue ={ (option, value) => option === value}
 value={formik.values.direction}
 name="direction"
 formik={formik}
 label="select way"
 height={"36px"}
 setTouched={setTouched}
 touched={touched}
/>
        {formik.touched.direction && Boolean(formik.errors.direction) && (
            <FormHelperText sx={{ color: "#d32f2f" }}>
              {formik.errors.direction}
            </FormHelperText>
          )}
</Box>

</Box>
</Grid>


<Grid item xs={12} mb={3}>
<Box
display={"flex"}
gap={"10px"}
>
<Box>
<InputLabel
           
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: "bold",
                letterSpacing: "-0.5px",
                lineHeight: "16px",
                marginBottom: "5px",
                pb: 1,
                pt: 1,
              }}
            >
               Field
    </InputLabel>

    <FormikAutocomplete 
 options={messageFields && messageFields.length > 0 ? [...messageFields,{id:0,name:"All"}].reverse() : []}
 value={formik.values.messageField}
 componentsProps= {{ popper: { style: { width: 'auto' } } }}
 getOptionLabel={(option) => (option.name ? option.name : '')}
 name="messageField"
 formik={formik}
 label="select field"
 height={"36px"}
 setTouched={setTouched}
 touched={touched}
/>
        {formik.touched.messageField && Boolean(formik.errors.messageField) && (
            <FormHelperText sx={{ color: "#d32f2f" }}>
              {formik.errors.messageField}
            </FormHelperText>
          )}
   
</Box>

<Box>
<InputLabel
              
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: "bold",
                letterSpacing: "-0.5px",
                lineHeight: "16px",
                marginBottom: "5px",
                pb: 1,
                pt: 1,
              }}
            >
               Operator
    </InputLabel>

    <FormikAutocomplete 
 options={operatorOptionsText}
 width={200}
 isOptionEqualToValue ={ (option, value) => option === value}
 value={formik.values.operator}
 name="operator"
 formik={formik}
 label="select operator"
 height={"36px"}
 setTouched={setTouched}
 touched={touched}
/>
             
               {formik.touched.operator && Boolean(formik.errors.operator) && (
            <FormHelperText sx={{ color: "#d32f2f" }}>
              {formik.errors.operator}
            </FormHelperText>
          )}
</Box>

<Box>
<InputLabel
             
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: "bold",
                letterSpacing: "-0.5px",
                lineHeight: "16px",
                marginBottom: "5px",
                pb: 1,
                pt: 1,
             
              }}
            >
            Text
    </InputLabel>
    <TextareaAutosize
    style={styleAuto}
    
    value={formik.values.value}
    name="value"
    onChange={handleChange}
    
    ></TextareaAutosize>
    {/* <TextField
            
                sx={{
                  width: "360px",
                  borderRadius: "4px",
                  "& .MuiInputBase-root": { height: "37px" },
                  "& .MuiOutlinedInput": { height: "36px" },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "1px solid #DBDEE6",
                  },
                }}
                value={formik.values.value}
                name="value"
                onChange={handleChange}
              /> */}
               {formik.touched.value && Boolean(formik.errors.value) && (
            <FormHelperText sx={{ color: "#d32f2f" }}>
              {formik.errors.value}
            </FormHelperText>)}
</Box>

</Box>
</Grid>


<Grid item xs={12}>
   
<CustomRadiobtn
            selectedValue={alertTypeValue}
            handleChangeSelection={HandleChangeChannel}
            labelName={"Alert Channel"}
            options={[
              {
                value: "SMS",
                label: "SMS",
              },

              {
                value: "EMAIL",
                label: "EMAIL",
              },
            ]}
          />
           {formik.touched.notificationType && Boolean(formik.errors.notificationType) && (
            <FormHelperText sx={{ color: "#d32f2f" }}>
              {formik.errors.notificationType}
            </FormHelperText> )}
  <InputLabel
              htmlFor="bankName"
              sx={{
                color: "#050D2E",
                fontSize: ".875rem",
                fontWeight: "bold",
                letterSpacing: "-0.5px",
                lineHeight: "16px",
                marginBottom: "5px",
                pb: 1,
                pt: 1,
                mt:2,
              }}
            >
               Choose Template
    </InputLabel>

    <FormikAutocomplete 
 options={Templates.Text}
 getOptionLabel={(option) => (option.name ? option.name : '')}
 width={200}
 value={formik.values.templateId}
 name="templateId"
 formik={formik}
 label="select Template"
 height={"36px"}
 setTouched={setTouched}
 touched={touched}
/>
  </Grid>

  <div style={{marginBottom:"10px"}}>

{alertTypeValue === "SMS" && <Grid item xs={12}>
     <InputLabel
       sx={{
         color: "#050D2E",
         fontSize: ".875rem",
         fontWeight: "bold",
         letterSpacing: "-0.5px",
         lineHeight: "16px",
         marginBottom: "5px",
         pb: 1,
         pt: 1,
         mt: 2,
       }}
     >
       Recipient Phone
     </InputLabel>

     <MultipleSelect
       options={[]}
       width={"536px"}
        handleChangeSelection={handleChangeEmail}
       selectedValue={selectedReceivers}
      
     />
       {formik.touched.receivers && Boolean(formik.errors.receivers) && (
       <FormHelperText sx={{ color: "#d32f2f" }}>
         {formik.errors.receivers}
       </FormHelperText> )}
     </Grid>
     }
 {alertTypeValue === "EMAIL" &&   <Grid item xs={12}>
     <InputLabel
       sx={{
         color: "#050D2E",
         fontSize: ".875rem",
         fontWeight: "bold",
         letterSpacing: "-0.5px",
         lineHeight: "16px",
         marginBottom: "5px",
         pb: 1,
         pt: 1,
         mt: 2,
       }}
     >
       Recipient Email
     </InputLabel>

     <MultipleSelect
       options={[]}
       width={"536px"}
       handleChangeSelection={handleChangeEmail}
       selectedValue={selectedReceivers}
      
     />
       {formik.touched.receivers && Boolean(formik.errors.receivers) && (
       <FormHelperText sx={{ color: "#d32f2f" }}>
         {formik.errors.receivers}
       </FormHelperText> )}
     <InputLabel
       sx={{
         color: "#050D2E",
         fontSize: ".875rem",
         fontWeight: "bold",
         letterSpacing: "-0.5px",
         lineHeight: "16px",
         marginBottom: "5px",
         pb: 1,
         pt: 1,
         mt: 2,
       }}
     >
       Email CC
     </InputLabel>

     <MultipleSelect
       options={[]}
       width={"536px"}
       handleChangeSelection={handleChangeccEmail}
       selectedValue={selectedccReceivers}
     />

   </Grid>}
</div>
    
    <CustomButton
                    text="Save Criteria"
                    processing={false}
                    disabled={!touched}
                    type="dark"
                    action={formik.handleSubmit}
                  />



</>


    </>
  )
}

export default AlertOnText